<template>

</template>

<script>
    import {mapState, mapGetters} from 'vuex';

    export default {
        data(){
            return {
                sectionType: "footer",
            }
        },
        computed: {
            ...mapState('footer',[
                'activeFooterStatus',
            ]),
            ...mapGetters('pages',[
                'pageProperties'
            ]),
            isActiveFooter () {
                return this.pageProperties.has_footer && this.activeFooterStatus === this.footerStatus;
            },

        },
        methods:{
             sectionCreationStartCallback () {
                this.setFooterStatus();
            },
        }
    }
</script>
